<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { ChevronLeft } from "lucide-vue-next";
import { PaginationPrev, type PaginationPrevProps } from "reka-ui";
import { cn } from "@/shared/lib/utils";
import { buttonVariants } from "@/shared/components/ui/button";

const props = defineProps<
  PaginationPrevProps & {
    class?: HTMLAttributes["class"];
  }
>();
</script>

<template>
  <PaginationPrev
    v-bind="props"
    :class="cn(buttonVariants({ variant: 'ghost', size: 'default' }), props.class)"
  >
    <slot>
      <ChevronLeft class="size-4 shrink-0" />
      Prev
    </slot>
  </PaginationPrev>
</template>
